export default {"src":"/bnb/_next/static/media/theme_light.7e84f055.svg","height":24,"width":24};